import { jsx as _jsx } from "react/jsx-runtime";
import { Divider } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useCallback } from 'react';
import styles from './item.module.scss';
export const VariableSelectorItem = ({ className, item, onSelect, }) => {
    const handleClick = useCallback(() => {
        onSelect(item);
    }, [onSelect, item]);
    if ('divider' in item) {
        return _jsx(Divider, { size: "xSmall" });
    }
    if ('content' in item) {
        const rootClass = classnames({
            [styles.root]: true,
        }, className);
        return (_jsx("button", Object.assign({ type: "button", className: rootClass, onClick: handleClick }, { children: item.content })));
    }
    return null;
};
